<template>
	<div
		class="flex items-center h-full w-full md:max-w-[25%] min-h-[56px] pl-0 sm:pl-4 md:pl-6 pr-0 sm:pr-4 pb-3 md:pb-0 mt-3 md:mt-0 justify-between"
	>
		<div class="flex flex-col h-full justify-center gap-y-[5px]">
			<span class="text-dj-gray-dark text-sm font-medium">
				{{ $t("jobs.detailedSearchbar.expiringJobs.title") }}
			</span>
			<span class="text-xs text-dj-gray w-[180px]">
				{{ $t("jobs.detailedSearchbar.expiringJobs.description") }}
			</span>
		</div>
		<BaseSwitch v-model="expiringJobs" class="flex-col sm:flex-row"></BaseSwitch>
	</div>
</template>

<script lang="ts">
import { defineComponent, computed, onMounted } from "vue";

export default defineComponent({
	name: "SearchbarJobsDetailedExpiringJobs",
	props: {
		modelValue: {
			type: Boolean,
			default: false,
			required: true,
		},
	},
	emits: ["update:modelValue"],
	setup(props, { emit }) {
		const route = useRoute();

		onMounted(() => {
			const query = route.query;

			if (query.expiring) {
				emit("update:modelValue", true);
			}
		});

		watch(
			() => route.query,
			(query) => {
				if (query.expiring) {
					emit("update:modelValue", true);
				}
			}
		);

		const expiringJobs = computed({
			get() {
				return props.modelValue;
			},
			set(value) {
				emit("update:modelValue", value);
			},
		});

		return {
			expiringJobs,
		};
	},
});
</script>
